module.exports = __webpack_public_path__ + "static/img/buylogo.d0f6485.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/procurement/buylogo.png
// module id = BcvN
// module chunks = 1